import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { AppContext } from '../../context/AppContext';

const Layout = () => {
  const { textStyles } = useContext(AppContext);

  return (
    <div className="min-h-screen bg-nba-dark">
      <Navbar />
      <main className="pt-[92px] pb-20 px-4 max-w-7xl mx-auto relative z-10">
        <Outlet />
      </main>
      <footer className="border-t border-nba-border py-12 px-6 mt-20 bg-nba-card">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="font-league italic uppercase tracking-widest dyn-footerTitle">
            {textStyles.footerTitle?.text}
          </div>
          <div className="font-league space-y-1 uppercase tracking-widest text-center md:text-right">
            <p className="dyn-footerSub1">{textStyles.footerSub1?.text}</p>
            <p className="dyn-footerSub2">{textStyles.footerSub2?.text}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;